import { createAction } from 'redux-actions';

export const createResource = createAction('CREATE_RESOURCE');
export const createResourceSuccess = createAction('CREATE_RESOURCE_SUCCESS');
export const createResourceFailure = createAction('CREATE_RESOURCE_FAILURE');

export const updateResource = createAction('UPDATE_RESOURCE');
export const updateResourceSuccess = createAction('UPDATE_RESOURCE_SUCCESS');
export const updateResourceFailure = createAction('UPDATE_RESOURCE_FAILURE');

export const deleteResource = createAction('DELETE_RESOURCE');
export const deleteResourceSuccess = createAction('DELETE_RESOURCE_SUCCESS');
export const deleteResourceFailure = createAction('DELETE_RESOURCE_FAILURE');

export const loadResource = createAction('LOAD_RESOURCE');
export const clearResource = createAction('CLEAR_RESOURCE');

export function loadResourceData(data) {
	return {
		type: loadResource,
		payload: data
	};
}
